import {useEffect} from 'react';

import base64IconsForIOS from '../assets/base64/base64IconsForIOS';
import envVariables from '../consts/envVariables';
import {strCode} from '../consts/strCode';
import {t} from '../services/localization/localizationService';
import themeService from '../services/themeService';
import {userBrowserService} from '../services/userBrowserService';
import uaUtils from '../utils/uaUtils';

const usePrepareHead = () => {
    useEffect(() => {
        const isIos = uaUtils.getIsIOS();
        const ogTitleStr = isIos ? strCode.OG_META_TITLE_IPHONE : strCode.OG_META_TITLE_DEFAULT;

        setThemeColorMetaTag();
        setMetaTagContent('og:title', t(ogTitleStr));

        setPreconnectLink(envVariables.IAP_CONSENTS_CLOUDFRONT_URL);
        setPreconnectLink(envVariables.IAP_CONFIGURATION_CLOUDFRONT_URL);
        setIconsLink();
    }, []);
};

const setMetaTagContent = (property, content) => {
    let metaTag = document.querySelector(`meta[property="${property}"]`);

    if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', property);
        document.head.appendChild(metaTag);
    }

    metaTag.setAttribute('content', content);
};

const setIconsLink = () => {
    try {
        Object.keys(base64IconsForIOS).forEach((size) => {
            setIconLinkTag('apple-touch-icon', size, base64IconsForIOS[size]);
        });
    } catch (err) {
        console.error('Error setting icon link tags:', err);
    }
};

const setIconLinkTag = (rel, sizes, href) => {
    let linkTag = document.querySelector(`link[rel="${rel}"][sizes="${sizes}"]`);

    if (!linkTag) {
        linkTag = document.createElement('link');
        linkTag.setAttribute('rel', rel);
        linkTag.setAttribute('sizes', sizes);
        document.head.appendChild(linkTag);
    }

    linkTag.setAttribute('href', href);
};

const setPreconnectLink = (href) => {
    if (!href) return;

    let preconnectLink = document.querySelector(`link[rel="preconnect"][href="${href}"]`);

    if (!preconnectLink) {
        preconnectLink = document.createElement('link');
        preconnectLink.setAttribute('rel', 'preconnect');
        preconnectLink.setAttribute('href', href);
        document.head.appendChild(preconnectLink);
    }
};

const setThemeColorMetaTag = () => {
    const isIos = uaUtils.getIsIOS();
    const isPWA = userBrowserService.getIsPWA();

    if (isIos && !isPWA) return;

    let metaTag = document.querySelector('meta[name="theme-color"]');

    if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', 'theme-color');
        document.head.appendChild(metaTag);
    }

    const color = themeService.getSelectedThemeColor();

    metaTag.setAttribute('content', color);
};

export default usePrepareHead;
